import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './UiLandingFooterBioderma.styles';

export interface UiLandingFooterBiodermaProps {
  bgFooter: {
    sm: string;
    md: string;
  };
  footnotes?: Array<{
    id: string;
    content: React.ReactNode;
  }>;
}

export function UiLandingFooterBioderma({
  bgFooter,
  footnotes
}: UiLandingFooterBiodermaProps) {
  const slots = styles();
  const t = useTranslations();
  type FooterBgVars = React.CSSProperties &
    Record<'--footer-bg-sm' | '--footer-bg-md', string>;
  const style: Partial<FooterBgVars> = {};
  if (bgFooter.sm) style['--footer-bg-sm'] = `url(${bgFooter.sm})`;
  if (bgFooter.md) style['--footer-bg-md'] = `url(${bgFooter.md})`;

  return (
    <footer className={slots.base()}>
      {footnotes && (
        <div className={slots.footnotes()}>
          {footnotes.map((footnote) => (
            <p
              key={footnote.id}
              className={slots.footnote()}
            >
              {footnote.content}
            </p>
          ))}
        </div>
      )}
      <div
        className={slots.container()}
        style={style}
      >
        <div className={slots.top()}>
          <div className={slots.logo()}>
            <Image
              className={slots.logoImage()}
              src={staticMediaUrl('landing/naos-ecobiology.png')}
              alt="logo"
              width={184}
              height={51}
            />
            <div
              className={slots.text()}
              dangerouslySetInnerHTML={{
                __html: t('landing.footer.titleBioderma')
              }}
            />
          </div>
          <Link
            className={slots.phone()}
            href="tel:88007759359"
          >
            8 800 775 93 59
          </Link>
        </div>
        <div className={slots.bottom()}>
          <ul className={slots.list()}>
            <li className={slots.listItem()}>{t('landing.footer.rights')}</li>
            <li className={slots.listItem()}>{t('landing.footer.company')}</li>
          </ul>
          <Link
            className={slots.link()}
            target="_blank"
            href="/legal/politika-konfidentsialnosti/"
          >
            {t('landing.footer.privacyLink')}
          </Link>
        </div>
      </div>
    </footer>
  );
}
